import axios from "axios";

// En producción el frontend y la API comparten dominio (Caddy reparte /api), así que la URL va vacía
export const API = `${process.env.REACT_APP_BACKEND_URL || ""}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

// concello del evento abierto en el editor: el servidor lo usa (solo para el administrador general) para aplicar las
// correcciones del callejero de ese concello en todas las consultas de calles y desvíos
let concelloEvento = "";
export const setConcelloEvento = (c) => { concelloEvento = c || ""; };
api.interceptors.request.use((cfg) => {
  if (concelloEvento) cfg.headers["X-Concello-Evento"] = concelloEvento;
  return cfg;
});

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const cfg = error.config;
    if (error.response?.status === 401 && !cfg._retry && !cfg.url.includes("/auth/")) {
      cfg._retry = true;
      refreshing = refreshing || api.post("/auth/refresh").finally(() => (refreshing = null));
      try {
        await refreshing;
        return api(cfg);
      } catch (e) {
        return Promise.reject(error);
      }
    }
    return Promise.reject(error);
  }
);

export function errMsg(e) {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || "Algo ha fallado. Inténtelo de nuevo.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => d?.msg || JSON.stringify(d)).join(" ");
  return detail.msg || String(detail);
}
